
import React from 'react';
import Stack from '@mui/material/Stack';
import { useState, useEffect, useRef } from 'react';
import FormControl from '@mui/material/FormControl';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import { useTranslation } from "react-i18next";
import {
    Card, Divider, Box, Grid, RadioGroup, FormControlLabel, Radio, TextField, Checkbox,
    ListSubheader, ListItemText, Button
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';


export default function SubscriptionFee() {
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };



    const [Dis, setDis] = useState(false);
    const [spinner, setSpinner] = React.useState(false);
    const [isActive, setisActive] = useState(2);
    const [Fee, setFee] = useState('');
    const [AllClientTemplatesList, setAllClientTemplatesList] = useState([]);
    const [ClientTemplatesIds, setClientTemplatesIds] = useState([]);

    const { t } = useTranslation();
    const menuListRef = useRef(null);
    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
                width: 200,
            },
        },
    };

    useEffect(() => {
        GetMembershipFeeDetails();
        GetAllClientTemplates();
    }, []);


    const GetAllClientTemplates = async () => {
        axios.get("SystemUser/GetAllClientTemplates")
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    setAllClientTemplatesList(res?.data?.data);
                    setClientTemplatesIds(res?.data?.data?.filter(t => t.isSelected === true));
                }
            }).catch((err) => {
                console.log(err);
            })
    }
    const groupedData = Object.values(
        AllClientTemplatesList?.reduce((acc, item) => {
            if (!acc[item.clientName]) {
                acc[item.clientName] = {
                    clientName: item.clientName,
                    templates: []
                };
            }

            acc[item.clientName].templates.push({
                clientTemplateId: item.clientTemplateId,
                clientId: item.clientId,
                templateName: item.templateName,
                isSelected: item.isSelected
            });

            return acc;
        }, {})
    ).sort((a, b) =>
        a.clientName.localeCompare(b.clientName, undefined, { sensitivity: "base" })
    );
    const allTemplates = groupedData.flatMap(client =>
        client.templates.map(t => ({
            ...t,
            clientName: client.clientName
        }))
    );
    const isSelected = (id) =>
        ClientTemplatesIds.some(t => t.clientTemplateId === id);

    const handleSelectAll = (checked) => {
        setClientTemplatesIds(
            checked
                ? allTemplates.map(t => ({ ...t, isSelected: true }))
                : []
        );
    };
    const toggleItem = (item) => {
        setClientTemplatesIds((prev) => {
            const exists = prev.some(
                t => t.clientTemplateId === item.clientTemplateId
            );

            return exists
                ? prev.filter(
                    t => t.clientTemplateId !== item.clientTemplateId
                )
                : [...prev, { ...item, isSelected: true }];
        });
    };

    const GetMembershipFeeDetails = async () => {
        setSpinner(true);
        axios.get("SystemUser/GetMembershipFee")
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    if (res?.data?.data == null) {
                        setisActive(2);
                        setFee('');
                    } else {
                        setFee(res?.data?.data?.membershipFee);
                        setisActive(res?.data?.data?.isActive == true ? 1 : 2);
                    }
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                }
            }).catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setSpinner(false);
            });
    }

    const SaveMembershipFee = async () => {
        setSpinner(true);
        setDis(true);

        if ((Fee >= 0 && isActive == 1 && ClientTemplatesIds?.length != 0)
            || (Fee >= 0 && isActive == 2 && (ClientTemplatesIds?.length == 0 || ClientTemplatesIds?.length != 0))) {
            const ClientTemIdsList = ClientTemplatesIds?.map((r) => ({
                clientTemplateId: r?.clientTemplateId,
                clientId: r?.clientId,
                clientName: r?.clientName,
                templateName: r?.templateName,
                isSelected: r?.isSelected
            }));
            const data = {
                "membershipFee": Fee,
                "isActive": isActive == 1 ? true : false,
                "clientTemplatesViewModels": isActive == 1 ? ClientTemIdsList : []
            }
            axios.post("SystemUser/PostMembershipFee", data)
                .then((res) => {
                    if (res?.data?.responseCode == 100) {
                        GetMembershipFeeDetails();
                        GetAllClientTemplates();
                        toastNotify(res?.data?.responseMessage, true);
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setSpinner(false);
                    setDis(false);
                });
        } else {
            toastNotify("Please enter mandatory fields", false);
            setDis(false);
            setSpinner(false);
        }
    }


    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3>Subscription Fee Configuration</h3>
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <Box >
                    <div className='mx-4'>
                        <Stack direction={"row"}>
                            <span className='mt-2' style={{ color: "#3E4A62" }}>Subscription Fee:  <span style={{ color: "red" }}>*</span></span>
                            <TextField
                                className='mx-5'
                                size='small'
                                sx={{ width: "320px" }}
                                value={Fee}
                                InputProps={{ inputProps: { min: "0" } }}
                                type='number'

                                onChange={(e) => {
                                    const val = e?.target?.value;
                                    if (val >= 0) {
                                        setFee(val);
                                    } else {
                                        setFee(0);
                                    }
                                }} />
                        </Stack>
                    </div>
                    <div className='mx-4 mt-3 '>

                        <Stack direction={"row"}>
                            <span className='mt-2' style={{ color: "#3E4A62" }}>Is Active:  <span style={{ color: "red" }}>*</span></span>
                            <FormControl>
                                <RadioGroup
                                    sx={{ paddingLeft: "120px" }}
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    value={isActive}
                                    onClick={(e) => {
                                        GetAllClientTemplates();
                                        setisActive(e?.target?.value);
                                    }}
                                >
                                    <Stack direction={"row"} spacing={5}>
                                        <FormControlLabel value={1} control={<Radio />} label="Yes" />
                                        <FormControlLabel value={2} control={<Radio />} label="No" />
                                    </Stack>

                                </RadioGroup>
                            </FormControl>
                        </Stack>
                    </div>

                    <div className='mx-4 mt-3 ' hidden={isActive == 2}>
                        <span style={{ color: "#3E4A62" }}>Client Templates:  <span style={{ color: "red" }}>*</span></span>
                        <Select
                            className="mx-5"
                            multiple
                            size="small"
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                width: '320px',
                            }}
                            value={ClientTemplatesIds}
                            renderValue={(selected) =>
                                selected.map(t => t.templateName).join(', ')
                            }
                            MenuProps={{
                                ref: menuListRef,
                                PaperProps: MenuProps.PaperProps,
                            }}
                        >
                            <MenuItem
                                hidden={AllClientTemplatesList?.length == 0}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const isChecked = ClientTemplatesIds.length === allTemplates.length;
                                    handleSelectAll(!isChecked);
                                }}
                            >
                                <Checkbox
                                    indeterminate={
                                        ClientTemplatesIds.length > 0 &&
                                        ClientTemplatesIds.length < allTemplates.length
                                    }
                                    checked={ClientTemplatesIds.length === allTemplates.length}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const isChecked = ClientTemplatesIds.length === allTemplates.length;
                                        handleSelectAll(!isChecked);
                                    }}
                                />
                                <ListItemText primary="Select All" />
                            </MenuItem>

                            {groupedData.flatMap((client) => [
                                <ListItemText
                                    sx={{ backgroundColor: '#f5f5f5', padding: "8px" }}
                                >
                                    <span
                                        className='mx-2'
                                        style={{
                                            display: 'inline-block',
                                            fontWeight: "bolder",
                                            fontSize: '15px',
                                            color: '#000',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word'
                                        }}
                                    >{client.clientName}</span>
                                </ListItemText>,

                                ...client.templates.map((template) => {
                                    const valueObj = {
                                        ...template,
                                        clientName: client.clientName,
                                    };

                                    return (
                                        <MenuItem
                                            key={template.clientTemplateId}
                                            onClick={() => toggleItem(valueObj)}
                                            title={template.templateName}
                                        >
                                            <Checkbox checked={isSelected(template.clientTemplateId)} />
                                            <ListItemText primary={template.templateName} />
                                        </MenuItem>
                                    );
                                }),
                            ])}

                        </Select>


                    </div>



                    <div className='mx-4 mt-3 mb-3 text-right'>
                        <Button variant="contained" sx={{ padding: "15px" }} disabled={Dis} onClick={SaveMembershipFee}> Save </Button>
                    </div>


                </Box >

            </Card>

        </>
    )
}


